<template>
  <div class="tile is-child">
    <svgicon
      v-if="icon"
      class="left tile-header-icon"
      :name="icon"
      :width="iconSize"
      :height="iconSize">
    </svgicon>
    <router-link v-if="link" class="right" :to="link">
      <svgicon
        class="tile-header-icon"
        name="link2"
        :width="iconSize"
        :height="iconSize">
      </svgicon>
    </router-link>
    <div
      v-if="header"
      class="level tile-header tile-highlight"
      :class="{ 'header-link': link }"
      @click="headerClick">
      <div class="level-item middle">
        <slot name="title"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tile',
  props: {
    link: {
      default: null,
    },
    icon: {
      type: String,
    },
    iconSize: {
      type: String,
      default: '20px',
    },
    header: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    headerClick() {
      if (this.link) {
        this.$router.push(this.link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left {
  position: absolute;
  top: .1rem;
  left: .1rem;
}

.right {
  position: absolute;
  top: .1rem;
  right: .1rem;
}

.header-link {
  cursor: pointer;
}

.tile-header {
  padding: .1rem;
  align-items: start; // Pull the icons to the top of the tile
  margin: 0;

  .middle {
    padding: .3rem;
    flex-shrink: 1;
  }

  .small {
    flex: 0;
  }
}
</style>
